import { h } from "preact";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { Text } from "../../../components/text";
import { Center } from "../../../style/styled";
import { TagCompoent } from "../../../components/tag/styled";
import { getPropertiesStatus } from "../../../functions";
import { IColumnData } from "../interfaces/table";

export const COULMN_DATA = (props?: any): IColumnData[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "รหัสคำขอ",
    dataIndex: "requestNo",
    key: "requestNo",
    width: "8em",
  },
  {
    title: "หมายเลขการเปลี่ยน",
    dataIndex: "maintainChangeId",
    key: "maintainChangeId",
    width: "10em",
    render: (text) => {
      return <Text size={"S"} text={text as string} bold={true} />;
    },
  },
  {
    title: "หมายเลขการซ่อม",
    dataIndex: "maintainId",
    key: "maintainId",
    width: "10em",
  },
  {
    title: "หมายเลขเครื่องตัด",
    dataIndex: "deviceId",
    key: "deviceId",
    width: "10em",
  },
  {
    title: "version เครื่องตัด",
    dataIndex: "versionMachine",
    key: "versionMachine",
    width: "10em",
  },
  {
    title: "รหัสเซลล์",
    dataIndex: "saleCode",
    key: "saleCode",
    width: "10em",
  },
  {
    title: "รหัสลูกค้า",
    dataIndex: "customerCode",
    key: "customerCode",
    width: "10em",
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "customerName",
    key: "customerName",
    width: "10em",
  },
  {
    title: "สถานที่จัดส่ง",
    dataIndex: "addressName",
    key: "addressName",
    width: "30em",
    align: "left",
  },
  {
    title: "JournalId",
    dataIndex: "journalId",
    key: "journalId",
    width: "10em",
  },
  {
    title: "AXVoucher",
    dataIndex: "axVoucher",
    key: "axVoucher",
    width: "15em",
  },
  {
    title: "AXJournalId",
    dataIndex: "axJournalId",
    key: "axJournalId",
    width: "10em",
  },
  {
    title: "itemCode",
    dataIndex: "itemCode",
    key: "itemCode",
    width: "15em",
  },
  {
    title: "สถานะ",
    dataIndex: "maintainChangeStatus",
    key: "maintainChangeStatus",
    fixed: "right",
    width: "10em",
    render: (text) => {
      const { color, text: t } = getPropertiesStatus(`${text}`);
      return (
        <Center>
          <TagCompoent color={color}>{t}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "",
    key: "button",
    width: "10em",
    fixed: "right",
    render: (_record: any) => {
      return (
        <div>
          <Popconfirm
            placement="bottomRight"
            title={"คุณต้องการลบรายการ"}
            onConfirm={() => props.onDelete(_record)}
            okText="ใช่"
            cancelText="ไม่ใช่"
            disabled={_record.maintainChangeStatus === "STCH-100"}
          >
            {
              (
                <Button
                  type="primary"
                  shape="circle"
                  icon={(<DeleteOutlined />) as React.ReactNode}
                  style={{ marginRight: 10 }}
                  danger
                  disabled={_record.maintainChangeStatus === "STCH-100"}
                />
              ) as React.ReactNode
            }
          </Popconfirm>
          <Button
            type="primary"
            shape="circle"
            onClick={() => props.onEdit(_record)}
            disabled={_record.maintainChangeStatus === "STCH-100"}
            icon={(<EditOutlined />) as React.ReactNode}
          />
        </div>
      );
    },
  },
];
